// candidate result
export const CANDIDATE_KEY_GET_EXAM_RESULTS_LISTING = 'CANDIDATE_KEY_GET_EXAM_RESULTS_LISTING';
export const CANDIDATE_KEY_GET_EXAM_RESULTS_DETAILS = 'CANDIDATE_KEY_GET_EXAM_RESULTS_DETAILS';
export const CANDIDATE_KEY_GET_PSLE_EXAM_RESULTS_DETAILS =
    'CANDIDATE_KEY_GET_PSLE_EXAM_RESULTS_DETAILS';
export const CANDIDATE_KEY_POST_AUDIT_VIEW_RESULTS = 'CANDIDATE_KEY_POST_AUDIT_VIEW_RESULTS';
export const CANDIDATE_KEY_POST_AUDIT_APPLY_RESIT = 'CANDIDATE_KEY_POST_AUDIT_APPLY_RESIT';
